export default {
  // Navigation
  'nav.home': 'Home',
  'nav.play': 'How It Works',
  'nav.store': 'Rewards',
  'nav.teamBuilding': 'For Teams',
  'nav.events': 'Events',
  'nav.business': 'For Business',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.startPlaying': 'Start Playing',

  // Home Section
  'home.badge': 'Digital City Guide · Event Marketplace',
  'home.title1': 'Your Digital City Guide.',
  'home.slogan': 'Turn Cities Into Playgrounds.',
  'home.heroDesc': 'CitySeek shows you what\'s happening in your city and turns exploring it into a game. Find events, discover real places on foot, and pick up rewards as you go.',
  'home.startAdventure': 'Start Playing',
  'home.watchVideo': 'Watch Video',
  'home.feature1': 'Explore on Foot',
  'home.featureEvents': 'Find Events',
  'home.feature2': 'Verify Locations',
  'home.feature3': 'Earn Coins & Points',
  'home.feature4': 'Chat with Players',
  'home.feature5': 'Climb the Leaderboard',
  'home.feature6': 'Spend at Local Shops',
  'home.instantPlay': 'Works right in your browser. No app store, no download.',

  // Video Section
  'video.title': 'See CitySeek in Action',
  'video.subtitle': 'Watch how people are exploring Darmstadt right now.',
  'video.cta': 'Try it in your city',

  // Event Marketplace
  'marketplace.eyebrow': 'New · Event Marketplace',
  'marketplace.title': 'Your City\'s Event Marketplace',
  'marketplace.subtitle': 'See what\'s on near you, and meet the venues and artists behind it. Everything your city has to offer, all in one place.',
  'marketplace.filterNearby': 'Nearby',
  'marketplace.filterTrending': 'Trending',
  'marketplace.filterWeek': 'This Week',
  'marketplace.filterAll': 'All',
  'marketplace.events.title': 'Events',
  'marketplace.events.desc': 'Concerts, meetups, markets and pop-ups happening near you.',
  'marketplace.venues.title': 'Venues',
  'marketplace.venues.desc': 'Cafés, bars, galleries and stages. Get to know the places that make your city.',
  'marketplace.artists.title': 'Artists',
  'marketplace.artists.desc': 'Follow local performers and creators so you never miss their next show.',
  'marketplace.exploreCta': 'See What\'s On',
  'marketplace.partner.badge': 'For Business',
  'marketplace.partner.title': 'List your venue, events & artists',
  'marketplace.partner.subtitle': 'Get in front of locals who are already out exploring. Post your events, build a following, and bring more people through your door.',
  'marketplace.partner.point1': 'Put your events in front of people already out and about',
  'marketplace.partner.point2': 'Build a following for your venue and artists',
  'marketplace.partner.point3': 'See your reach, interest and redemptions',
  'marketplace.partner.listCta': 'List with CitySeek',
  'marketplace.partner.talkCta': 'Talk to us',

  // How It Works
  'howItWorks.title': 'How It Works',
  'howItWorks.step1.title': 'Pick a City & Game',
  'howItWorks.step2.title': 'Walk & Verify',
  'howItWorks.step3.title': 'Unlock Stories',
  'howItWorks.step4.title': 'Share Memories',
  'howItWorks.step5.title': 'Earn Rewards',

  // Game Modes
  'games.title': 'Our Game Categories',
  'games.subtitle': 'Different ways to explore and play',
  'games.core.title': 'Core Game',
  'games.core.desc': 'Explore the city at your own pace, with your own guide to the best spots in audio and text.',
  'games.weekly.title': 'Timely Challenge',
  'games.weekly.desc': 'Social events that wrap up at a local spot, with rewards to collect.',
  'games.custom.title': 'Custom Games',
  'games.custom.desc': 'Team events, uni tours, onboarding days and private groups.',

  // Store Section
  'store.title': 'CitySeek Store',
  'store.subtitle': 'Earn coins while you explore, then spend them at local cafés, restaurants and shops.',
  'store.step1': 'Collect Coins',
  'store.step1.desc': 'Finish tasks and earn as you explore',
  'store.step2': 'Browse Rewards',
  'store.step2.desc': 'See what local partners are offering',
  'store.step3': 'Redeem via QR',
  'store.step3.desc': 'Scan and redeem at partner spots',
  'store.cta': 'Visit Store',

  // Team Building / For Business
  'team.eyebrow': 'For Business & Teams',
  'team.title': 'City Adventures for Teams & Brands',
  'team.subtitle': 'Custom city games for companies, universities and organizers. Get everyone out of the meeting room and into the city together.',
  'team.audience1': 'Companies',
  'team.audience2': 'Universities',
  'team.audience3': 'Tour Operators',
  'team.audience4': 'Brands & Events',
  'team.benefit1': 'Natural Collaboration',
  'team.benefit1.desc': 'Teams work together naturally as they solve real challenges out in the city.',
  'team.benefit2': 'Active Engagement',
  'team.benefit2.desc': 'Walking and missions keep everyone energized and involved.',
  'team.benefit3': 'Creative Problem Solving',
  'team.benefit3.desc': 'Riddles, tasks and discovery bring out different skills and ideas.',
  'team.benefit4': 'Local Discovery',
  'team.benefit4.desc': 'Teams get to know their city together, with real context.',
  'team.benefit5': 'Better Communication',
  'team.benefit5.desc': 'Built-in chat keeps everyone talking and sharing the moment.',
  'team.benefit6': 'Measurable Results',
  'team.benefit6.desc': 'Track participation, completion and engagement in real time.',
  'team.whyChooseTitle': 'Why teams choose CitySeek',
  'team.whyChooseSubtitle': 'Leave the conference room behind and build connections that last.',
  'team.ctaTitle': 'Ready to bring your team together?',
  'team.ctaSubtitle': 'Let\'s build a city adventure your team will actually remember.',
  'team.cta1': 'Get Custom Quote',
  'team.cta2': 'Schedule Demo',

  // About Section
  'about.title': 'About CitySeek',
  'about.subtitle': 'A new way to experience your city.',
  'about.mission': 'Our Mission',
  'about.missionText': 'We want exploring your city to feel exciting again. So we turn real places into things to do, and help local businesses and culture thrive along the way.',
  'about.vision': 'Our Vision',
  'about.visionText': 'A world where every city is worth getting lost in.',
  'about.values': 'Our Values',

  'about.value1': 'Authentic Discovery',
  'about.value2': 'Community First',
  'about.value3': 'Quality Content',
  'about.value4': 'Playful Learning',
  'about.value5': 'Privacy & Safety',
  'about.value6': 'By Locals, For Locals',
  'about.value7': 'Supporting Local Businesses',
  'about.team': 'Team',
  'about.teamSubtitle': 'The people behind CitySeek',
  'about.team.safa': 'Leads product, partnerships and where CitySeek goes next.',
  'about.team.umut': 'Builds the tech that keeps CitySeek running smoothly.',
  'about.learnMore': 'How It Works',
  'about.getInTouch': 'Get In Touch',

  // Contact
  'contact.title': 'Say hello',
  'contact.subtitle': 'Want to list your venue, bring CitySeek to your city, or plan something with your team? We\'d love to hear from you.',
  'contact.email': 'Email',
  'contact.location': 'Location',
  'contact.address': 'Hilpertstraße 31, 64295 Darmstadt-West, Germany',
  'contact.response': 'Response Time',
  'contact.responseTime': 'Within 24 hours',
  'contact.ctaTitle': 'Ready to explore?',
  'contact.ctaSubtitle': 'Join the people already seeing their city in a whole new way.',
  'contact.ctaButton': 'Start Playing Now',
  'contact.form.getInTouch': 'Get In Touch',
  'contact.form.subtitle': 'Partnership, sponsorship or a team game? We\'re happy to chat.',
  'contact.form.nameLabel': 'Name *',
  'contact.form.namePlaceholder': 'Your Name',
  'contact.form.emailLabel': 'Email *',
  'contact.form.emailPlaceholder': 'you@company.com',
  'contact.form.companyLabel': 'Company',
  'contact.form.companyPlaceholder': 'Optional',
  'contact.form.cityLabel': 'City',
  'contact.form.cityPlaceholder': 'Optional',
  'contact.form.useCaseLabel': 'What is it about?',
  'contact.form.useCaseDefault': 'Choose a topic',
  'contact.form.useCase.listVenue': 'List a venue or event',
  'contact.form.useCase.artist': 'Artist / performer',
  'contact.form.useCase.partnership': 'Partnership',
  'contact.form.useCase.customGame': 'Custom game',
  'contact.form.useCase.teamAdventure': 'Team or group adventure',
  'contact.form.useCase.press': 'Press',
  'contact.form.useCase.other': 'Other',
  'contact.form.messageLabel': 'Message * (max 500 characters)',
  'contact.form.messagePlaceholder': 'How can we help?',
  'contact.form.sendButton': 'Send message',
  'contact.form.sending': 'Sending …',
  'contact.form.successTitle': 'Thanks, we got your message.',
  'contact.form.successMessage': 'We\'ll get back to you soon.',

  // Footer
  'footer.tagline': 'Your digital city guide and event marketplace. Real adventures, real rewards.',
  'footer.product': 'Product',
  'footer.howItWorks': 'How It Works',
  'footer.events': 'Events Marketplace',
  'footer.availableGames': 'Game Modes',
  'footer.store': 'Rewards Store',
  'footer.teamBuilding': 'For Teams',
  'footer.business': 'For Business',
  'footer.company': 'Company',
  'footer.about': 'About',
  'footer.contact': 'Contact',
  'footer.press': 'Press',
  'footer.legal': 'Legal',
  'footer.impressum': 'Impressum',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.cookies': 'Cookie Policy',
  'footer.allRights': 'All rights reserved.',
  'footer.social': 'Follow Us',

  // CityLab Pop-Up Widget
  'citylab.widget': 'CityLab Pop-Up',
  'citylab.title': 'CitySeek Pop-Up Darmstadt',
  'citylab.subtitle': 'Interactive gallery and cultural hotspot',
  'citylab.badge': 'March to May 2026',
  'citylab.visit': 'Visit',
  'citylab.location': 'Luisenplatz 5, Darmstadt'
};
